import dayjs from 'helpers/datetime'

export const isFutureMonthTermination = (
  terminationDate?: string | Date | null
): boolean => {
  if (!terminationDate) return false
  const term = dayjs(terminationDate)
  if (!term.isValid()) return false
  return term.format('YYYY-MM') > dayjs().format('YYYY-MM')
}

export const heldUntilDisplay = (
  terminationDate?: string | Date | null
): string => {
  if (!terminationDate) return ''
  const term = dayjs(terminationDate)
  if (!term.isValid()) return ''
  return term.startOf('month').format('MM/DD/YYYY')
}

export const onHoldUntilDisplay = (
  nextAttemptAt?: string | Date | null,
  terminationDate?: string | Date | null
): string => {
  if (nextAttemptAt) {
    const next = dayjs(nextAttemptAt)
    if (next.isValid()) {
      return next.utc().format('MM/DD/YYYY')
    }
  }
  return heldUntilDisplay(terminationDate)
}

// MM/DD/YY, as in "11/10/26". A date-only string is sliced so UTC midnight
// does not shift it to the previous calendar day.
export const terminationEffectiveDateDisplay = (
  terminationDate?: string | Date | null
): string => {
  if (!terminationDate) return ''
  if (typeof terminationDate === 'string') {
    const dateOnly = terminationDate.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (dateOnly) {
      const [, year, month, day] = dateOnly
      return `${month}/${day}/${year.slice(-2)}`
    }
  }
  const term = dayjs(terminationDate)
  if (!term.isValid()) return ''
  return term.format('MM/DD/YY')
}

export const onHoldTerminationMessage = (effectiveDate: string) =>
  `Request received for termination effective date of ${effectiveDate}. Process pending.`
